'use client'
import React, { FC } from 'react'
import classNames from 'classnames'

import BitcoinIcon from '@/icons/bitcoin-filled'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import { NETWORK_NAME } from '@/utils/constants'
import featureFlags from '@/utils/feature-flags'

const TopUpButtonGradient: FC<{
	className?: string
	onClick?: (evt?: any) => void
}> = (props) => {
	const { onClick, className } = props

	if (featureFlags('app::disable_trade')) {
		return <React.Fragment />
	}

	return (
		<ButtonGradientEpic
			onClick={onClick}
			className={classNames(className, 'w-full h-[52px] flex flex-row gap-3 items-center justify-center')}
		>
			<BitcoinIcon width={18} className="fill-foreground size-[22px] min-w-[22px]" />
			<span className="text-md font-semibold">
					Trade {NETWORK_NAME.toLowerCase()}
			</span>
		</ButtonGradientEpic>
	)
}

export default TopUpButtonGradient
